export default "__VITE_ASSET__qQMd7Cfx__"